module.exports = __webpack_public_path__ + "media/img/illustrations/pie-8fbf15c567652a7ac0500f14a9f89ff7.svg";